import React, { useState, useEffect } from 'react';
import { Card, Flex, Text, Grid, Select, Button } from '@radix-ui/themes';
import { Handle, Position } from 'reactflow';
import { CubeIcon } from '@radix-ui/react-icons';

import * as Types from '../../../../../types';
import { ValueType } from '../../../../../lib/workflow-defs';
import { WorkflowNodeProps } from '../..';

// Define supported units locally or move to workflow-defs
const supportedUnits = Object.entries(ValueType).map(([key, value]) => ({
  value,
  label: key,
}));

const UnitConverterNode = ({
  id,
  data,
  onChange,
}: WorkflowNodeProps<Types.TransformerNode>) => {
  return (
    <Grid columns="1" gap="4">
      <Flex align="center" gap="2">
        <CubeIcon />
        <Text as="div" size="2" weight="bold">
          Unit Converter
        </Text>
      </Flex>
      <Card variant="classic" mt="2">
        <Flex direction="column" gap="3">
          <Flex direction="row" gap="2" justify="between">
            <Select.Root
              value={data.transformer.fromUnit}
              onValueChange={(value) =>
                onChange(id, {
                  ...data,
                  transformer: {
                    ...data.transformer,
                    fromUnit: value as ValueType,
                  },
                })
              }
            >
              <Select.Trigger placeholder="From Unit" />
              <Select.Content>
                {supportedUnits.map(({ value, label }) => (
                  <Select.Item key={value} value={value}>
                    {label}
                  </Select.Item>
                ))}
              </Select.Content>
            </Select.Root>

            <Select.Root
              value={data.transformer.toUnit}
              onValueChange={(value) =>
                onChange(id, {
                  ...data,
                  transformer: {
                    ...data.transformer,
                    toUnit: value as ValueType,
                  },
                })
              }
            >
              <Select.Trigger placeholder="To Unit" />
              <Select.Content>
                {supportedUnits.map(({ value, label }) => (
                  <Select.Item key={value} value={value}>
                    {label}
                  </Select.Item>
                ))}
              </Select.Content>
            </Select.Root>
          </Flex>
        </Flex>
        <Handle
          id="input-value"
          type="target"
          position={Position.Left}
          style={{ background: 'blue' }}
        />
        <Handle
          id="output-value"
          type="source"
          position={Position.Right}
          style={{ background: 'orange' }}
        />
      </Card>
    </Grid>
  );
};

export default UnitConverterNode;
